import React, { useCallback, useContext, useRef } from "react";

import importScript from "../../hooks/importScript";

import { OccurrenceFrequency } from "./OccurrenceFrequency";
import { OccurrenceProperties } from "./OccurrenceProperties";
import { OccurrenceFrequencyLevel } from "../../classes/dates/occurrence_frequency";
import { GoalOccurrencePropsShape } from "../../interfaces/componentTypes";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

export const GoalOccurrence: React.FunctionComponent<GoalOccurrencePropsShape> = ({
  approved,
  contextOrigin,
}) => {
  importScript("/assets/kanayo/src/util.js?body=1");
  const { t } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(contextOrigin);

  const handleOccurrenceFrequency = useCallback((e) => {
    setGoalState((prevState) => {
      return {
        ...prevState,
        occurrenceFrequency: OccurrenceFrequencyLevel.findById(e.id),
      };
    });
  }, []);

  const handleContinuous = useCallback((e) => {
      e.persist();
    setGoalState((prevState) => {
      return {
        ...prevState,
        continuous: e.target.value == "true" ? true : false,
      };
    });
  }, []);

  const handleOccurrenceAmount = useCallback((value) => {
    setGoalState((prevState) => {
      return {
        ...prevState,
        occurrenceAmount: value,
      };
    });
  }, []);

  const displayTypeAndAmount = () => {
    if (goalState.occurrenceFrequency != null) {
      return (
        <OccurrenceProperties
          handleOccurrenceAmount={handleOccurrenceAmount}
          context={contextOrigin}
          handleContinuous={handleContinuous}
        />
      );
    }
  };

  return (
    <div
      className="goal-boxed-input-area"
      style={{ display: `${approved ? "block" : "none"}` }}
    >
      <div className="goal-form-input-row">
        <span className="goal-input-area-title full-width">
          {t("views.goals.headings.frequency_title")}
        </span>
      </div>

      <OccurrenceFrequency
        context={contextOrigin}
        handleTimeframe={handleOccurrenceFrequency}
      />
      {displayTypeAndAmount()}
    </div>
  );
};
